import {AppConsts} from "cf/packages/abpVue/AppConsts";
import AbpHttp from "cf/packages/abpVue/http/AbpHttp.js";

class Mobile {
  constructor() {
    this.wxReady = false;

  }


  isYzjApp() {
    if(navigator.userAgent.match(/App\/cloudhub/)){
      return true;
    }
    return navigator.userAgent.match(/Qing\/.*;(iOS|iPhone|Android).*/) ? true : false;
  }

  isWxApp() {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      return true;
    } else {
      return false;
    }
  }

  isDD() {
    var ua = navigator.userAgent;
    if (ua.match(/DingTalk/i) == "DingTalk") {
      return true;
    } else {
      return false;
    }
  }

  getOS() {
    return (navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) ? 'iOS' :
      navigator.userAgent.match(/Android/i) ? 'Android' : '');
  }

  isCordova() {
    return navigator.userAgent == 'CordovaApp';
  }

  //2.0未使用
  PreviewImage(currentImage, imageList, callback) {
    if (this.isYzjApp()) {
      XuntongJSBridge.call('previewImage',
        {
          'current': currentImage,
          'urls': imageList
        },
        function (result) {
          //2017-10-23 因为云之家不返回回调参数， 此处不再callback
        });
      //2017-10-23不等待结束，直接callback
      if (callback) {
        callback({success: true});
      }
    }
  }

//2.0未使用
  PreviewFile(fileName, fileExt, fileUrl, fileSize, callback) {
    if (this.isYzjApp()) {
      XuntongJSBridge.call('showFile',
        {
          'fileName': fileName,
          'fileExt': fileExt,
          'fileTime': moment().format('YYYY-MM-DD HH:mm:ss'),
          'fileSize': fileSize,
          'fileDownloadUrl': fileUrl
        },
        function (result) {
          callback();
        }
      );
    }
  }

//2.0未使用
  PreviewImageCordova(pdfUrl, pdfTitle, callback, useInAppBrowser) {
    var devicePlatform = device.platform;
    if (devicePlatform == 'iOS' || useInAppBrowser == true) {
      var ref = cordova.InAppBrowser.open(pdfUrl, '_blank', 'location=no,closebuttoncaption=关闭,enableViewportScale=yes');

      ref.addEventListener("exit", function () {
        callback({success: true})
      });
    } else {
      AndroidNativePdfViewer.openPdfUrl(pdfUrl, pdfTitle, {
        headerColor: "#000000",
        showScroll: true,
        showShareButton: false,
        showCloseButton: true,
        swipeHorizontal: false
      }, function (success) {
        if (callback)
          callback({success: true});
      }, function (error) {
        if (callback)
          callback({success: false});
      });
    }
  }

  closeView() {
    if (this.isYzjApp()) {
      XuntongJSBridge.call('closeWebView');
    } else if (this.isCordova()) {

    } else if (this.isWxApp()) {
      wx.closeWindow();
    } else if (AppConsts.rsa_home_url == "goBackInNavigation()") {
      nativeObj.goBackInNavigation(); //31使用的特殊代码
    } else {
      window.location.href = AppConsts.rsa_home_url || (AppConsts.appBaseUrl + "/#/" + "Login"); //todo:测试
    }
  }

//2.0未使用 - 不再使用
  HideHeader() {
    if (this.isYzjApp()) {
      XuntongJSBridge.call('setWebViewTitleBar', {'isShow': false});
    }
  }

  //云之家
  getUserInfo(callback) {
    XuntongJSBridge.call('getPersonInfo', {}, function (result) {
      if (typeof result == 'string') {
        result = JSON.parse(result);
      }
      callback(result);
    });
  }

//2.0未使用
  rotateUI(orientation, callback) {
    XuntongJSBridge.call('rotateUI',
      {orientation: orientation},
      function (result) {
        if (callback) {
          callback()
        }
      }
    );
  }

  getLocation(callback) {
    if (this.isWxApp()) {
      wx.getLocation({
        type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: function (res) {
          var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
          var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。

          var point = new BMap.Point(longitude, latitude);

          var geoc = new BMap.Geocoder();
          geoc.getLocation(point, function (rs) {

            callback({
              success: true,
              data: {
                latitude: latitude,
                longitude: longitude,
                addressdetail: rs.address
              }
            })
          });
        },
        error: function (res) {
          if (res.errMsg == 'getLocation:permission denied') {
            abp.notify.error('没有权限获取定位，请打开企业微信获取定位权限.')
          }
          callback({
            success: false
          })
        }
      });

    } else if (this.isYzjApp()) {
      XuntongJSBridge.call(AppConsts.yun_localtion, {}, function (result) {
        if (typeof result == 'string') {
          result = JSON.parse(result);
        }
        callback(result);
      });
    } else {
      var geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(function (r) {
        if (this.getStatus() == BMAP_STATUS_SUCCESS) {
          var geoc = new BMap.Geocoder();
          geoc.getLocation(r.point, function (rs) {
            callback({
              success: true,
              data: {
                latitude: r.latitude,
                longitude: r.longitude,
                addressdetail: rs.address
              }
            })
          });
        } else {
          callback({
            success: false
          })
        }
      }, {enableHighAccuracy: true})
    }
  }

//2.0未使用
  createRightMenu(title, callback) {
    XuntongJSBridge.call('createPop', {
      'popTitle': title,
      'popTitleCallBackId': "title"
    }, function (resp) {
      if (resp.success == true || resp.success == 'true') {
        var callBackId = resp.data ? resp.data.callBackId : '';
        if (callBackId == 'title') {
          callback();
        }
      }
    });
  }

//2.0未使用
  cleanRightMenu() {
    XuntongJSBridge.call('closePop');
  }

  setTitle(title) {
    if (this.isYzjApp()) {
      XuntongJSBridge.call('setWebViewTitle', {'title': title});
    } else {
      document.title = title;
    }
  }

  scanQR(callback) {
    if (this.isYzjApp()) {
      XuntongJSBridge.call("scanQRCode", {
        "needResult": callback ? 1 : 0
      }, function (result) {
        callback(result);
      });
    } else if (this.isWxApp()) {
      wx.scanQRCode({
        needResult: callback ? 1 : 0, // 默认为0，扫描结果由企业微信处理，1则直接返回扫描结果，
        scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {
          callback({
            success: true,
            data: {
              qrcode_str: res.resultStr
            }
          });
        },
        error: function (res) {
          if (res.errMsg.indexOf('function_not_exist') > 0) {
            abp.notify.warn('版本过低请升级')
          }
          callback({success: false})
        }
      });
    } else if (this.isCordova()) {
      cordova.plugins.barcodeScanner.scan(
        function (result) {
          window.location.href = result.text;
        },
        function (error) {
          alert("Scanning failed: " + error);
        },
        {
          "preferFrontCamera": false, // iOS and Android
          "showFlipCameraButton": false, // iOS and Android
          "showTorchButton": true, // iOS and Android
          "disableAnimations": true, // iOS
          "prompt": "请将二维码放在正中区域", // supported on Android only
          "formats": "QR_CODE", // default: all but PDF_417 and RSS_EXPANDED
          "orientation": "portrait" // Android only (portrait|landscape), default unset so it rotates with the device
        }
      );
    }
  }

  selectPic(callback) {
    if (this.isYzjApp()) {
      XuntongJSBridge.call('selectPic', {'type': ''}, function (result) {
        callback(result);
      });
    } else if (this.isWxApp()) {
      wx.chooseImage({
        count: 1, // 默认9
        sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
        // defaultCameraMode: "batch", //表示进入拍照界面的默认模式，目前有normal与batch两种选择，normal表示普通单拍模式，batch表示连拍模式，不传该参数则为normal模式。（注：用户进入拍照界面仍然可自由切换两种模式）
        success: function (res) {
          var localIds = res.localIds; // 返回选定照片的本地ID列表，
          wx.getLocalImgData({
            localId: localIds[0], // 图片的localID
            success: function (res) {
              var localData = res.localData; // localData是图片的base64数据，可以用img标签显示
              callback({
                success: true,
                data: {
                  fileExt: localData.fileExt,
                  fileData: localData.fileData
                }
              });
            }
          });
        },
        error: function () {
          callback({success: false});
        }
      });
    } else if (this.isCordova()) {
      navigator.camera.getPicture((sResult) => {
        callback({
          success: true,
          data: {
            fileExt: "image/jpeg",
            fileData: sResult
          }
        });
      }, eResult => {
        callback({
          success: false
        })
      }, {
        quality: 50,
        destinationType: Camera.DestinationType.DATA_URL
      });
    }
  }

  configShare() {
    XuntongJSBridge.call('createPop',
      {
        'menuList': ['forward', 'refresh', 'share'],
        'shareData': {
          'url': window.location.href,
        }
      },
      function (resp) {
      }
    );
  }

  defBack() {
    // XuntongJSBridge.call('closePop');

    XuntongJSBridge.call('defback',
      {},
      function () {
        vm.navLeft();
      }
    );
  }

  initWechat() {
    window.wx = require('weixin-js-sdk');
    vm.http.request('/wx/cp/portal/getSign', {url: window.location.href.split('#')[0]}).then(res => {
      wx.config({
        beta: true,// 必须这么写，否则wx.invoke调用形式的jsapi会有问题
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: res.item.appId, // 必填，企业微信的corpID
        timestamp: res.item.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.item.nonceStr, // 必填，生成签名的随机串
        signature: res.item.signature,// 必填，签名，见附录1
        jsApiList: ['getLocation', 'previewFile', 'uploadImage', 'hideAllNonBaseMenuItem', 'closeWindow', 'scanQRCode', 'onHistoryBack'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      });
      wx.ready(function () {
        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
        console.log('wx ready');
        this.wxReady = true;
        // wx.hideAllNonBaseMenuItem();
        wx.onHistoryBack(function () {
          vm.navLeft();
        });
      });
      wx.error(function (res) {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        console.log('wx error');
        abp.notify.error("微信JS SDK加载失败,请检查配置参数");
        this.wxReady = false;
      });
    }).finally(t => {
    });
  }

  initDD() {
    window.dd = require('dingtalk-jsapi');

    vm.http.request('/wx/cp/portal/getSign', {url: window.location.href.split('#')[0]}).then(res => {
      dd.config({
        agentId: res.item.agentId, // 必填，微应用ID
        corpId: res.item.corpId,//必填，企业ID
        timeStamp: res.item.timeStamp, // 必填，生成签名的时间戳
        nonceStr: res.item.nonceStr, // 必填，生成签名的随机串
        signature: res.item.signature, // 必填，签名
        type: 0,   //选填。0表示微应用的jsapi,1表示服务窗的jsapi；不填默认为0。该参数从dingtalk.js的0.8.3版本开始支持
        jsApiList: [
          'runtime.info',
          'biz.contact.choose',
          'device.notification.confirm',
          'device.notification.alert',
          'device.notification.prompt',
          'biz.ding.post',
          'biz.util.openLink',
        ] // 必填，需要使用的jsapi列表，注意：不要带dd。
      });
      dd.ready(() => {
        // dd.ready参数为回调函数，在环境准备就绪时触发，jsapi的调用需要保证在该回调函数触发后调用，否则无效。
        dd.runtime.permission.requestAuthCode({
          corpId: AppConsts.site.dd_corp_id,
          onSuccess: (result) => {
            abp.utils.setCookieValue("dd_code", result.code);
          },
          onFail: (err) => {
          }
        });
      });
    }).finally(t => {
    });


  }

}

export default new Mobile()



// WEBPACK FOOTER //
// ./src/assets/Mobile.js